import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import {
  cancellationInsideEu,
  cancellationOutsideEu,
  cancelForAnyReason,
  flexibleTicket,
  seatMap,
} from '@eti/products';
import { travelerForm } from '@eti/travelers';
import { price } from '@eti/utils';
import sumBy from 'lodash/sumBy';
import ReviewModal from '../components/review-modal/ReviewModal';
import { TRAVELER_DETAILS } from '../../../constants/formNamesConstants';
import {
  getAddedExtraProducts,
  getExtraProductsTotalPrice,
} from '../../../utils/addedExtraProducts';
import {
  getCFARTicketProduct,
  getFlexibleTicketProduct,
  getSeatMapProduct,
  getCancellationProduct,
} from '../utils/availableExtraProducts';
import { CONTACT_INFO_FORM_SECTION, contactFields } from '../constants/formFields';
import { flattenProducts } from '../utils/products';

const { EMAIL, PHONE, PHONE_COUNTRY_ID } = contactFields;

const transformTravelers = (form, state, travelers) => {
  const getFormValue = formValueSelector(form);
  return travelers.map((traveler, index) => {
    const { ageType } = traveler;
    const firstName = travelerForm.getSelectedFirstName(form)(state, index);
    const lastName = travelerForm.getSelectedLastName(form)(state, index);
    const dateOfBirth = travelerForm.getSelectedDateOfBirth(form)(state, index);
    const mail = index === 0 ? getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${EMAIL}`) : null;
    const phone = index === 0 ? getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${PHONE}`) : null;
    const phoneCountry =
      index === 0 ? getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${PHONE_COUNTRY_ID}`) : null;

    return {
      ageType,
      firstName,
      lastName,
      dateOfBirth,
      mail,
      phone,
      phoneCountry,
    };
  });
};

const findProductById = (products) => (productId) =>
  flattenProducts(products).find((product) => Number(product.id) === productId);

const getExtraProducts = (form, state, productNames, products) => {
  const getIdFor = findProductById(products);

  const cancellationInsideEuProduct = getIdFor(cancellationInsideEu.id);
  const cancellationOutsideEuProduct = getIdFor(cancellationOutsideEu.id);
  const flexibleTicketProduct = getIdFor(flexibleTicket.id);
  const cfarTicketProduct = getIdFor(cancelForAnyReason.id);
  const seatMapProduct = getIdFor(seatMap.id);

  return [
    ...getCFARTicketProduct(form, productNames, cfarTicketProduct)(state),
    ...getFlexibleTicketProduct(form, productNames, flexibleTicketProduct)(state),
    ...getSeatMapProduct(form, productNames, seatMapProduct)(state),
    ...getCancellationProduct(form, productNames, cancellationInsideEuProduct)(state),
    ...getCancellationProduct(form, productNames, cancellationOutsideEuProduct)(state),
  ];
};

const mapStateToProps = (
  state,
  { form, travelerPrices, travelers, productNames, products, voucherAmount },
) => {
  const totalTripPrice = sumBy(travelerPrices, 'price.price.value');
  const extraProductsTotalPrice = getExtraProductsTotalPrice(TRAVELER_DETAILS)(state);
  const discountAmount = voucherAmount?.value ?? 0;

  return {
    discountAmount,
    extraProducts: getExtraProducts(form, state, productNames, products),
    seatMap: formValueSelector(form)(state, 'seatMap') || {},
    selectedProducts: getAddedExtraProducts(TRAVELER_DETAILS, productNames)(state),
    totalPrice: totalTripPrice + extraProductsTotalPrice - discountAmount,
    travelers: transformTravelers(form, state, travelers),
  };
};

const mapDispatchToProps = (dispatch, { form, products, setIsSeatMapModalOpen = () => {} }) => ({
  onAdd: (fieldName, value) => {
    const getIdFor = findProductById(products);

    const flexibleTicketProduct = getIdFor(flexibleTicket.id);

    if (fieldName === seatMap.name) {
      dispatch(change(form, 'seatMap.value.value', 'true'));
      setIsSeatMapModalOpen(true);
    }

    if (fieldName === cancellationInsideEu.name || fieldName === cancellationOutsideEu.name) {
      dispatch(change(form, fieldName, value));
    }

    if (fieldName === flexibleTicket.name) {
      const flexibleTicketValue = [];

      flexibleTicketProduct.sellSpecification.sellPriceTravelers.forEach((traveler) =>
        flexibleTicketValue.push({
          closeMenuOnSelect: false,
          price: price.formatPrice(traveler.price.price.value),
          priceRaw: traveler.price.price.value,
          value: traveler.travelerId,
        }),
      );

      dispatch(
        change(form, flexibleTicket.name, {
          value: [...flexibleTicketValue],
        }),
      );
    }

    if (fieldName === cancelForAnyReason.name) {
      dispatch(change(form, fieldName, value));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewModal);
